"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {TitleSectionEspacePro} from "@/components/common/title-section-espace-pro";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Directeur Général et Ordonnateur"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                    {
                                        title: "Qui sommes-nous ?",
                                        link: "/espace-pro/office-de-tourisme/qui-sommes-nous"
                                    },
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

                <p className={"text-normal mb-8"}>
                    Madame <strong>Malékah MOURAD-CONDE</strong> nommée par Décret N°2021-483 du 8 septembre 2021.Ces
                    missions d’accueil, d’information et de conseil des visiteurs, de la promotion de la destination, de
                    la commercialisation de prestations touristiques, de l’observation de l’activité touristique, et de
                    la coordination des acteurs du tourisme sont assurées par 5 pôles aux compétences diverses.
                </p>

                <TitleSectionEspacePro title={"Biographie"} />

                <p className={"text-normal mb-8"}>
                    Ivoirienne, mariée et mère de deux enfants, Madame <strong>Malékah MOURAD-CONDE</strong> est
                    économiste et comptable de formation. Elle totalise plus de 25 années d’expérience professionnelle.
                    Spécialiste des fonctions administratives et comptables, elle capitalise des expertises dans le
                    développement des activités, la planification stratégique, le développement des produits et
                    l’analyse financière. Elle est médaillée dans l’ordre du mérite national de CÔTE D’IVOIRE depuis le
                    7 Août 2014.
                    <br/>
                    <br/>
                    Manager d’exception, volontaire, acharnée et déterminée, elle a joué, en tant que dirigeant social,
                    un rôle considérable autant dans la restructuration de l’entreprise en l’orientant client que, dans
                    la relance de l’industrie touristique dans la ville de Yamoussoukro à travers la gastronomie, le
                    sport et l’écotourisme.
                    <br/>
                    <br/>
                    De directeur de bureau du tourisme, à Directeur Général de Côte d’Ivoire Tourisme en passant par la
                    Direction Générale de SODERTOUR-LACS, son parcours est révélateur d’un caractère rigoureux empreint
                    d’une ambition forte de contribuer à la réduction de la pauvreté en milieu rural et de faire du
                    tourisme un levier de développement.
                    <br/>
                    <br/>
                    En tant que Directeur Général de SODERTOUR-LACS, elle a travaillé à l’élaboration de la stratégie de
                    restructuration et de développement de la Société, de réinvention de l’entreprise à travers une
                    nouvelle architecture de valeur, une nouvelle équation des profits et de nouvelles propositions de
                    valeurs afin de faire de Yamoussoukro, une destination touristique démocratisée (accessible à la
                    classe moyenne).
                    <br/>
                    <br/>
                    Ces résultats n’auraient pas pu être atteints sans le capital humain à travers le développement des
                    compétences internes et la mise en place des indicateurs de performances et des objectifs
                    quantitatifs et qualitatifs.
                    <br/>
                    <br/>
                    Aujourd’hui à la tête de l’office national du tourisme, toujours poussée par sa passion pour le
                    tourisme, cette visionnaire de génie et innovatrice de haut vol ambitionne d’améliorer
                    considérablement la gouvernance et de renforcer la performance globale de COTE D’IVOIRE TOURISME
                    afin d’en faire une entreprise reconnue pour son leadership et son audace dans la construction et le
                    rayonnement de la destination COTE D’IVOIRE.
                    <br/>
                    <br/>
                    Pour y arriver, elle s’attèle chaque jour aux côtés de son équipe et des socioprofessionnels du
                    tourisme de poser les jalons avec force et conviction qui feront de la COTE D’IVOIRE une destination
                    touristique, durable, responsable et équitable, remarquée de tous.
                </p>

                <TitleSectionEspacePro title={"Exprériences Professionnelles :"} />

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li>Depuis le 8 septembre 2021 : DIRECTEUR GENERAL – CÔTE D’IVOIRE TOURISME</li>
                        <li>2011 à 2022 : DIRECTEUR GENERAL – SODERTOUR-LACS (Société de Développement Touristique de la
                            Région des Lacs)&nbsp;</li>
                    </ul>
                </div>

                <TitleSectionEspacePro title={"Distinctions :"} />

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li>Depuis 2022 : Professeur Vacataire des Universités et Grandes Ecoles</li>
                        <li>2021-2022 : Présidente du Comité d’Organisation du FORUM « Côte d’Ivoire Destination
                            Touristique » Editions 1 et 2
                        </li>
                        <li>20 Décembre 2021- 20 décembre 2022 : Ambassadeur de la chaire UNESCO pour la culture de la
                            paix&nbsp;</li>
                        <li>Octobre 2021- Août 2022 : Présidente de la Commission Hébergement et Restauration du Comité
                            d’Organisation de la Coupe d’Afrique des Nations de Football (COCAN 2023)
                        </li>
                        <li>7 Août 2014 : Officier dans l’Ordre National du Mérite&nbsp;</li>
                        <li>2013-2017 : Vice-Présidente de la Fédération Ivoirienne des Sports Equestres (FISE) chargée
                            des courses hippiques
                        </li>
                        <li>29 juin 2012 : Grande Médaille d’Honneur avec toutes les félicitations du Club de Coupe du
                            Monde de la Pâtisserie
                        </li>
                    </ul>
                </div>
            </SectionPage>

        </div>
    );
}
